module.exports = __webpack_public_path__ + "static/media/pose-head.2e69482f.jpg";